import Script from "next/script";

interface WeeztixCardProperties {
    shopUrl: string;
    guid?: string;
}

export function WeeztixCard({ shopUrl, guid }: WeeztixCardProperties) {
    return (
        <>
            <div className="relative z-30 w-full min-h-[600px] rounded-2xl overflow-hidden bg-freedom isolate">
                <div
                    className="ot-iframe h-full min-h-[600px] w-full relative z-0"
                    data-ot-url={shopUrl}
                    data-ot-guid={guid}
                />
                <Script
                    id="weeztix-script"
                    src="https://v1.widget.shop.weeztix.com/injector.js"
                    strategy="lazyOnload"
                />
            </div>
        </>
    );
}